
// TOPページの1stビュースライダー
const frontFvSlider = new Swiper(".p-fv__slider .swiper", {
  effect: 'fade',
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  centeredSlides: true,
});

// TOPページの導入企業ロゴスライダー
const frontLogoSlider = new Swiper(".p-fv__logoSlider .swiper", {
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  slidesPerView: 4,
  spaceBetween: 17,

  // ブレークポイント（画面幅による設定）
  breakpoints: {
    // 画面幅が 768px 以上の場合（window width >= 768px）
    768: {
      slidesPerView: 7,
      spaceBetween: 25
    },
    // 画面幅が 1024px 以上の場合（window width >= 1024px）
    1024: {
      slidesPerView: 9,
      spaceBetween: 30
    }
  },
});


// swiper PC3つ並び / TB2つ並び / SP1つ
const defaultSlider = new Swiper(".c-defaultSlider .swiper", {
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  slidesPerView: 1.2,
  spaceBetween: 20,
  centeredSlides: true,

  // ブレークポイント（画面幅による設定）
  breakpoints: {
    // 画面幅が 768px 以上の場合（window width >= 768px）
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // 画面幅が 1024px 以上の場合（window width >= 1024px）
    1024: {
      slidesPerView: 3,
      spaceBetween: 40
    }
  },
  pagination: {
    el: ".c-defaultSlider .swiper-pagination",
  },
  navigation: {
    nextEl: ".c-defaultSlider .swiper-button-next",
    prevEl: ".c-defaultSlider .swiper-button-prev",
  },
});